export type AppType = "Android" | "iOS" | "Web";

/**
 * 네이티브 WebView 가 User-Agent 끝에 부착하는 토큰으로 런타임 플랫폼을 판별한다.
 *   - maketrend/Android/{versionName}
 *   - maketrend/iOS/{versionName}
 * 토큰이 없으면 일반 웹 브라우저로 간주한다.
 *
 * ⚠️ prd 부팅 게이트(`shared/lib/storeGate.ts`)가 이 판별에 의존한다 — 토큰 부재 = 스토어 랜딩.
 *    네이티브 UA 계약을 바꾸면 상용 앱 전체가 랜딩에 막히므로 양쪽 동시 변경 필수.
 *    index.html 인라인 스크립트(data-platform)도 같은 토큰을 읽는다(변경 시 동기화).
 */

/** UA 문자열만으로 판별(순수). 게이트 판정(storeGate)·appType() 이 공유하는 유일한 토큰 소스. */
export const appTypeFromUserAgent = (ua: string): AppType => {
  if (ua.includes("maketrend/Android")) return "Android";
  if (ua.includes("maketrend/iOS")) return "iOS";
  return "Web";
};

export const appType = (): AppType => appTypeFromUserAgent(navigator.userAgent);
